import { render } from "./Shift.vue?vue&type=template&id=2d884230"
import script from "./Shift.vue?vue&type=script&lang=js"
export * from "./Shift.vue?vue&type=script&lang=js"

import "./Shift.vue?vue&type=style&index=0&id=2d884230&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__